module.exports = "/_next/static/images/80b5c25f35917bf02c5f826eeb109719-moneyboxes-right.jpg.webp";